export default async (truthyFunc, timeout, logLabel) => {
  var start = Date.now();
  return new Promise(waitForValue);
  function waitForValue(resolve, reject) {
    if (truthyFunc()) resolve(true);
    else if (Date.now() - start >= timeout) reject(new Error('Timeout waiting for ' + logLabel));
    else setTimeout(waitForValue.bind(this, resolve, reject), 100);
  }
};
